// extracted by mini-css-extract-plugin
export default {"graphsContainer":"Graphs_graphsContainer__PBNGy","rightSegment":"Graphs_rightSegment__qDBEz","leftCard":"Graphs_leftCard__HMMzR","rightCard":"Graphs_rightCard__v8XBr"};